<template>
  <div class="flex flex-wrap">
    <div class="masonry-content  relative w-full">
      <div class="flex flex-col">
        <div class="flex flex-wrap -my-2 -mx-5">
          <!-- Start Date -->
          <div class="flex flex-col w-full my-2 px-5">
            <label class="uppercase font-semibold text-sm">Start Date <span class="text-red-500">*</span></label>
            <Calendar
                appendTo="body"
                dateFormat="dd/mm/yy"
                v-model="contract.start_date"
                :showIcon="true"
            />
          </div>

          <!-- End Date -->
          <div class="flex flex-col w-full my-2 px-5">
            <label class="uppercase font-semibold text-sm">End Date</label>
            <Calendar
                appendTo="body"
                dateFormat="dd/mm/yy"
                v-model="contract.end_date"
                :showIcon="true"
            />
          </div>

          <!-- Contract Type -->
          <div class="flex flex-col w-full my-2 px-5">
            <label class="uppercase font-semibold text-sm">Contract Type</label>
            <input class="bge-input bge-input-spacing rounded" type="text" v-model="contract.contract_type" />
          </div>

          <!-- Payment Type -->
          <div class="flex flex-col w-full my-2 px-5">
            <label class="uppercase font-semibold text-sm">Payment Type</label>
            <input class="bge-input bge-input-spacing rounded" type="text" v-model="contract.payment_type" />
          </div>
        </div>
      </div>

      <div class="flex justify-end mt-5">
        <AppButton color="blue" @click="isEditMode ? updateContract() : createContract()" label="Save" :icon="true">
          <template v-slot:icon>
            <Icon iconType="save" class="mr-2" />
          </template>
        </AppButton>
      </div>
    </div>
  </div>
</template>

<script>
import notificationMixin from "@/mixins/notificationMixin";
import Icon from "@/components/Icon.vue";
import AppButton from "@/components/Button.vue";

export default {
  name: "AddContract",
  mixins: [notificationMixin],
  components: {
    AppButton,
    Icon,
  },
  props: {
    initial_contract: {
      type: Object,
      default: () => ({}),
    },
    equipment_id: {
      type: String,
      required: true,
    },
    contract_id: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      contract: {},
      isEditMode: !!this.contract_id,
    };
  },
  async mounted() {
    if (this.initial_contract) {
      this.contract = {
        ...this.initial_contract,
        start_date: this.initial_contract.start_date
            ? this.formatTimestamp(this.initial_contract.start_date)
            : null,
        end_date: this.initial_contract.end_date
            ? this.formatTimestamp(this.initial_contract.end_date)
            : null,
      };
    }
  },
  methods: {
    validateRequiredFields() {
      if (!this.contract.start_date) {
        this.notifyError("Start Date is required.");
        return false;
      }
      return true;
    },
    async createContract() {
      if (!this.validateRequiredFields()) return;

      try {
        const payload = {
          ...this.contract,
          start_date: this.contract.start_date
              ? this.$moment(this.contract.start_date, "DD-MM-YYYY").unix()
              : null,
          end_date: this.contract.end_date
              ? this.$moment(this.contract.end_date, "DD-MM-YYYY").unix()
              : null,
        };

        await this.EquipmentService.createContract(this.equipment_id, payload);
        this.notifySuccess("Contract added successfully");
        this.$emit("refreshEquipment");
      } catch (error) {
        this.notifyError("Couldn't add Contract");
        console.error(error);
      }
    },
    async updateContract() {
      if (!this.validateRequiredFields()) return;

      try {
        const payload = {
          ...this.contract,
          start_date: this.contract.start_date
              ? this.$moment(this.contract.start_date, "DD-MM-YYYY").unix()
              : null,
          end_date: this.contract.end_date
              ? this.$moment(this.contract.end_date, "DD-MM-YYYY").unix()
              : null,
        };

        await this.EquipmentService.updateContract(
            this.equipment_id,
            this.contract_id,
            payload
        );
        this.notifySuccess("Contract updated successfully");
        this.$emit("refreshEquipment");
      } catch (error) {
        this.notifyError("Couldn't update Contract");
        console.error(error);
      }
    },
    formatTimestamp(unixTimestamp) {
      return this.$moment.unix(unixTimestamp).format("DD-MM-YYYY");
    },
  },
};
</script>
